module.exports = __webpack_public_path__ + "img/contact_order.1a76e1a7.png";